import React from 'react';
import { LazyLoadComponent } from "react-lazy-load-image-component"
import PartnerSwiper from "../swiper/swiper-partner"

const PartnerSwiperSection = () => <LazyLoadComponent>
          <PartnerSwiper />
        </LazyLoadComponent>;

export default PartnerSwiperSection;
